import { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TableData, TableRow } from 'src/common/components/table/styles';

import { Table } from '../../../../../common';
import { useDrivers } from '../../hook';

export interface TableFilterProps {
    dateFrom?: Date | null;
    dateTo?: Date | null;
}

function TableImage({dateFrom, dateTo}: TableFilterProps) {
    const { t } = useTranslation();
    const { driverByImage, handleGetDriverListIdCluster, handleGetDriverIdCluster } = useDrivers();

    const hasDriver: boolean = driverByImage?.elements.filter(driver => driver.driver && driver.driver !== null).length !== 0;

    const tableHeaders = useMemo(() => {
        return hasDriver 
            ? [t('drivers.id_cluster'), t('drivers.operation'), t('drivers.driver'), t('drivers.similarity')]
            : [t('drivers.id_cluster'), t('drivers.operation'), t('drivers.similarity')]
    }, [t, hasDriver]);

    const handleClickedTable = useCallback((idCluster: string) => {
        handleGetDriverListIdCluster({
            dateFrom,
            dateTo,
            pageSize: 15,
            start: 1,
            id: idCluster
        });
        handleGetDriverIdCluster({
            dateFrom,
            dateTo,
            id: idCluster
        })
    },[dateFrom, dateTo, handleGetDriverIdCluster, handleGetDriverListIdCluster])


    return (
        <Table tableHeaders={tableHeaders}>
            {driverByImage?.elements.map(driver => (
                <TableRow onClick={() => handleClickedTable(driver.idCluster)} key={driver.idCluster.toString()} className="body pointer">
                    <TableData>{driver.idCluster}</TableData>
                    <TableData>{driver.operation}</TableData>
                    {hasDriver ? <TableData>{driver.driver}</TableData> : ''}
                    <TableData>{driver.similarity}</TableData>
                </TableRow>
            ))}
        </Table>
    );
}

export default memo(TableImage);
